var _defs, _path, _path2, _path3, _path4, _g, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartRate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #80c8da;\n      }\n\n      .cls-2 {\n        fill: #8d9092;\n      }\n\n      .cls-3 {\n        fill: #3f9ed7;\n      }\n\n      .cls-4 {\n        fill: #3f90ce;\n      }\n\n      .cls-5 {\n        fill: #45a9de;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M136.66,205.45h-43.81c-11.6,0-21.04-9.44-21.04-21.04v-56.41c0-9.27,14.02-9.28,14.02,0v56.41c0,3.87,3.15,7.01,7.01,7.01h43.81c3.87,0,7.01-3.15,7.01-7.01v-46.28c0-11.6,9.44-21.04,21.04-21.04h7.01c9.27,0,9.28,14.02,0,14.02h-7.01c-3.87,0-7.01,3.15-7.01,7.01v46.28c0,11.6-9.44,21.04-21.04,21.04Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M171.72,117.09h-7.01c-11.6,0-21.04,9.44-21.04,21.04v46.28c0,3.87-3.15,7.01-7.01,7.01h-8.66v14.02h8.66c11.6,0,21.04-9.44,21.04-21.04v-46.28c0-3.87,3.15-7.01,7.01-7.01h7.01c9.27,0,9.28-14.02,0-14.02Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M191.35,150.75c-14.69,0-26.65-11.95-26.65-26.65s11.95-26.65,26.65-26.65,26.65,11.95,26.65,26.65-11.95,26.65-26.65,26.65Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M203.51,124.1c0,6.71-5.44,12.15-12.15,12.15s-12.15-5.44-12.15-12.15c0-16.06,24.31-16.08,24.31,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38,78.13v-20.57c0-3.87,3.14-7.01,7.01-7.01h14.34c3.87,0,7.01,3.14,7.01,7.01s-3.14,7.01-7.01,7.01h-7.32v13.56c0,9.27-14.02,9.28-14.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.64,85.15c-3.87,0-7.01-3.14-7.01-7.01v-13.56h-7.32c-3.87,0-7.01-3.14-7.01-7.01s3.14-7.01,7.01-7.01h14.34c3.87,0,7.01,3.14,7.01,7.01v20.57c0,3.87-3.14,7.01-7.01,7.01Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38,94.19v-16.05c0-3.87,3.14-7.01,7.01-7.01h23.37c3.87,0,7.01,3.14,7.01,7.01v16.05c0,4.53,6.86,4.53,6.86,0v-16.05c0-3.87,3.14-7.01,7.01-7.01h23.37c3.87,0,7.01,3.14,7.01,7.01v16.05c0,10.9-4.25,21.16-11.96,28.87-25.54,25.52-69.7,7.52-69.7-28.87Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartRate);
export default __webpack_public_path__ + "static/media/heart-rate.99ee9272662ecf80d1470c4b44d5a5b0.svg";
export { ForwardRef as ReactComponent };